export const checkIsStripe = (paymentGateway) => {
  return paymentGateway?.provider === "Stripe" && paymentGateway?.keys?.publicKey;
};

export const checkIsTranzila = (paymentGateway) => {
  return paymentGateway?.provider === "Tranzila";
};
